import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Grid } from '@material-ui/core';

import { useCurrentUser } from '@klp/auth';
import { useAppParams } from '@klp/core/app/useAppParams';
import { Heading } from '@klp/design';
import { Loader } from '@klp/design/Loader';
import { Main } from '@klp/layout';

import type { IMessageInput } from '../classes';
import { Message } from '../classes';
import { MessageForm } from '../components';
import { MessageBoardRoutes } from '../config';
import { useGetMessageQuery, usePostMessageMutation } from '../rtkApi';

export const MessageEdit: React.FC = () => {
    const history = useHistory();
    const { messageId, selectedClient } = useAppParams();
    const { isAdmin } = useCurrentUser();

    const { data, isLoading: loading } = useGetMessageQuery({
        isAdmin,
        id: messageId ? parseInt(messageId, 10) : undefined,
        selectedKunde: selectedClient?.kundeNummer,
    });

    const [postMessage, { isLoading: saving, data: saveResult }] =
        usePostMessageMutation();

    const message = data?.message;
    const saved = saveResult?.message;

    useEffect(() => {
        if (saved) {
            history.push(MessageBoardRoutes.single(saved.id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saved]);

    const onSubmit = async (event: React.FormEvent, values: IMessageInput) => {
        event.preventDefault();
        await postMessage(Message.parseObject(values));
    };

    const onCancel = () => {
        history.push(
            MessageBoardRoutes.single(
                messageId ? parseInt(messageId, 10) : undefined,
            ),
        );
    };

    if (!(message && isAdmin)) {
        return null;
    }

    return (
        <Main>
            <Loader isLoading={loading}>
                <Grid container={true}>
                    <Grid item={true} sm={12} md={12}>
                        <Heading
                            klpHeadingLevel="ONE"
                            translation="message.editMessage"
                        />
                        <MessageForm
                            mode="edit"
                            message={message}
                            onSubmit={onSubmit}
                            onCancel={onCancel}
                            disabled={saving}
                            isLoading={saving}
                        />
                    </Grid>
                </Grid>
            </Loader>
        </Main>
    );
};
